import styled from 'styled-components'

import { defaultDndColor } from '../../helpers'

import { ReactComponent as BarIcon } from './icons/bar.svg'
import { ReactComponent as ExitIcon } from './icons/exit.svg'
import { ReactComponent as WcIcon } from './icons/wc.svg'

import { ReactComponent as DoubleDoorsIcon } from './icons/doubleDoors.svg'
import { ReactComponent as LeftDoorIcon } from './icons/doorLeft.svg'
import { ReactComponent as RightDoorIcon } from './icons/doorRight.svg'

import { ReactComponent as TreeIcon } from './icons/tree.svg'
import { ReactComponent as BushIcon } from './icons/bush.svg'
import { ReactComponent as PlantIcon } from './icons/plant.svg'

import { ReactComponent as SofaIcon } from './icons/sofa.svg'
import { ReactComponent as ChairIcon } from './icons/chair.svg'
import { ReactComponent as BarChairIcon } from './icons/barChair.svg'


const Template = styled.div`
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	margin: 2px;
	padding: 2px;
	background: ${defaultDndColor};
	width: 25px;
	height: 25px;
`

export const Round = styled(Template)`
	border-radius: 50%;
	width: 25px;
	height: 25px;
`

export const Rectangle = styled(Template)`

`

export const hWall = styled(Template)`
	width: 25px;
	height: 5px;
	background: white;
	border: 1px solid #cdcdcd;
`

export const vWall = styled(Template)`
	width: 5px;
	height: 25px;
	background: white;
	border: 1px solid #cdcdcd;
`

export const hWindow = styled(Template)`
	width: 25px;
	height: 5px;
	background: repeating-linear-gradient(-45deg,#7ac8ff 0,#7ac8ff 1px,#7ac8ffa3 1px,#7ac8ffa3 4px);
`

export const vWindow = styled(Template)`
	width: 5px;
	height: 25px;
	background: repeating-linear-gradient(-45deg,#7ac8ff 0,#7ac8ff 1px,#7ac8ffa3 1px,#7ac8ffa3 4px);
`

export const Column = styled(Template)`
	border-radius: 50%;
	background: white;
	border: 1px solid #cdcdcd;
`

export const Tree = styled(TreeIcon)`
	border-radius: 50%;
	width: 50px;
	height: 50px;
`

export const Bush = styled(BushIcon)`
	border-radius: 50%;
	width: 40px;
	height: 40px;
`

export const Plant = styled(PlantIcon)`
	border-radius: 50%;
	width: 30px;
	height: 30px;
`

export const Bar = styled(BarIcon)`
	width: 27px;
	height: 27px;
`

export const Exit = styled(ExitIcon)`
	width: 25px;
	height: 25px;
`

export const Chair = styled(ChairIcon)`
	width: 33px;
	height: 33px;
`
export const BarChair = styled(BarChairIcon)`
	width: 35px;
	height: 35px;
`

export const Sofa = styled(SofaIcon)`
	width: 55px;
	height: 55px;
`

export const Wc = styled(WcIcon)`
	width: 35px;
	height: 35px;
`

export const DoorLeft = styled(LeftDoorIcon)`
	width: 35px;
	height: 45px;
`

export const DoorRight = styled(RightDoorIcon)`
	width: 35px;
	height: 45px;
`

export const DoubleDoors = styled(DoubleDoorsIcon)`
	width: 70px;
	height: 45px;
`
